import React from 'react'

import './privacy.css'

const Privacy = () => {

  return (
    <>
      <title>Privacy Policy</title>
      <div className='privacy-section-wrapper'>
        
      </div>
    </>
  )
}

export default Privacy